import { CompiledAgreementBlock, DocumentPayloadMap } from 'bff'
import { translate } from 'i11n'
import { DocumentFooter } from '../../components/DocumentFooter'
import { DocumentHeader } from '../../components/DocumentHeader'
import { DocumentPage } from '../../components/DocumentPage'
import { KeyValueList } from '../../components/KeyValueList'
import { AgreementRichText } from '../../components/AgreementRichText'
import { PageBreak } from '../../components/PageBreak'
import { SignatureSlot } from '../../components/SignatureSlot'
import { Watermark } from '../../components/Watermark'

type AgreementProps = DocumentPayloadMap['agreement']

/**
 * El texto llega compilado (bff `compileAgreementTemplate`) y el snapshot
 * persistido es exactamente este payload: acá se dibuja, no se decide nada.
 */
const renderBlock = (block: CompiledAgreementBlock) => {
  switch (block.kind) {
    case 'title':
      return (
        <h2 className='text-center text-[12pt] font-semibold uppercase tracking-wide'>
          {block.text}
        </h2>
      )
    case 'paragraph':
      return (
        <p className='whitespace-pre-line text-justify'>
          <AgreementRichText text={block.text} />
        </p>
      )
    case 'clause':
      return (
        <p className='whitespace-pre-line text-justify'>
          <span className='font-semibold'>
            {block.ordinal}
            {block.title ? ` — ${block.title}` : ''}:{' '}
          </span>
          <AgreementRichText text={block.text} />
        </p>
      )
    case 'key_values':
      return (
        <KeyValueList
          labelClassName='text-[7pt]'
          items={block.rows.map((row) => ({
            label: row.label,
            value: <AgreementRichText text={row.value} rich={false} />,
          }))}
        />
      )
    case 'signatures':
      return (
        <div className='flex flex-wrap gap-x-10 gap-y-3 pt-3'>
          {block.slots.map((slot) => (
            <SignatureSlot key={slot.key} slot={slot} />
          ))}
        </div>
      )
    case 'page_break':
      return <PageBreak />
  }
}

const AgreementDefault = ({
  meta,
  document,
  blocks,
  watermark,
}: AgreementProps) => (
  <DocumentPage className='flex min-h-full flex-col gap-4 text-[9pt]'>
    {watermark && <Watermark text={watermark} />}

    {/* <DocumentHeader meta={meta} /> */}

    <div className='flex flex-col gap-4'>
      {blocks.map((block) => (
        <div key={block.id}>{renderBlock(block)}</div>
      ))}
    </div>

    {/* <DocumentFooter>
      {translate('document.agreement.footer', {
        id: document.id,
        version: String(document.version),
        template: document.template_name,
      })}
    </DocumentFooter> */}
  </DocumentPage>
)

export default AgreementDefault
